export default "__VITE_ASSET__DVcYK$bc__"